import(/* webpackMode: "eager", webpackExports: ["BlogClientView"] */ "/app/apps/web/components/blog/BlogClientView.tsx");
